export const required = (value) => {
    return value.trim() !== '';
}

export const minLength = (value, minLength) => {
    return value.length >= minLength;
}

export const maxLength = (value, maxLength) => {
    return value.length <= maxLength;
}

export const isEmail = (value) => {
    const pattern = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    return pattern.test( value );
}

export const isUsernameValid = (value) => {
    const pattern = /^[a-zA-Z0-9 ._-]+$/
    return pattern.test( value );
}

export const isNumeric = (value) => {
    const pattern = /^\d+$/;
    return pattern.test( value );
}

export const isChecked = (value) => {
    return parseInt(value, 2) > 0; //check in base 2
}

export const isPasswordSecured = (value) => {
    const pattern = /^(?=.*[0-9])(?=.*[a-z])(.{6,})$/i;
    return pattern.test( value );
}

export const isBirthdayDateValid = (value) => {
    const pattern = /^((19|20)[0-9]{2}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])|(0[1-9]|[1-2][0-9]|3[0-1])(-|\/)?(0[1-9]|1[0-2])(-|\/)?(19|20)[0-9]{2})$/;
    return pattern.test( value );
}


// WEBPACK FOOTER //
// ./src/conf/validators.js